/* eslint-disable no-param-reassign */
/* eslint-disable arrow-parens */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Card,
  Form,
  Button,
  Row,
  Col,
  Spin,
  message,
  Input,
  Tabs,
  InputNumber,
  DatePicker,
  TreeSelect,
} from 'antd';
import API from 'utils/api';
import moment from 'moment';
import { DATE_FRONTEND_FORMAT } from 'utils/normalizers';
import { formatReceived } from 'utils/formatValues';
import { onError } from 'utils/handlers';
import { useSelector } from 'react-redux';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import {
  getFuentesDeFinanciamiento,
  getFuentesDeFinanciamientoContabilidad,
} from 'api/catalogos/index';
import { checkToken } from 'api/utils';
import { NOMBRES_PATTERN } from 'utils/patterns';

import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import {
  postConfiguracionSeguroIMSS,
  deleteConfiguracionSeguroIMSS,
  patchConfiguracionSeguroIMSS,
  getConfiguracionesSeguroIMSS,
} from 'api/catalogos/ConfiguracionSeguroIMSS';
import {
  getCatalogosDeModalidadDeSeguridadSocial,
} from 'api/catalogos/ModalidadDeSeguridadSocial';
import {
  getSeguridadsociales,
} from 'api/catalogos/SeguridadSocial';
import {
  getBaseDeCalculos,
} from 'api/catalogos/BaseDeCalculo';
import {
  getPeriodicidadDeSeguridadSociales,
} from 'api/catalogos/PeriodicidadDeSeguroSocial';
import {
  getClasificacionesTipoGasto,
} from 'api/catalogos/ClasificacionTipoGasto';
import {
  getClasificadoresObjetoGastoUnion,
} from 'api/configuraciones/clasificadorObjetoGasto';

import {
  getCatalogosDeCuentasContablesPasivo,
} from 'api/catalogos/CatalogoDeCuentasContablesPasivo';
import {
  getCuentasContablesPasivoPatronal,
} from 'api/catalogos/CuentasContablesPasivoPatronal';
import {
  getCuentasContablesPasivoEmpleado,
} from 'api/catalogos/CuentasContablesPasivoEmpleado';
import { getCentrosDeCostos } from 'api/catalogos/CentroDeCostos';
import { getUnidadesResponsables } from 'api/catalogos/UnidadesResponsables';
import { getUnidadesOperativas } from 'api/catalogos/UnidadesOperativas';

import {
  getValoresParaElCalculo,
} from 'api/catalogos/ValorParaElCalculo';
import { getCuentasContables } from 'api/catalogos/CuentaContable';
import makeTreeCuentasContable from 'utils/makeTreeFromCuentasContables';
import makeTree from 'utils/makeTree';

const { TabPane } = Tabs;

export const onErrorFields = (
  err,
  setLoading = null,
  formsInstances = [],
  setCurrentTabKey,
  setCurrentTabKeyDO,
  setCurrentParentTabKey,
) => {
  if (typeof setLoading === 'function') {
    setLoading(false);
  }
  const errorKeys = err.errorFields.map((e) => e.name[0]);
  const formWithErrors = formsInstances.find(
    (obj) => obj.tabFields.some(
      (val) => errorKeys.includes(val),
    ),
  );
  if (formWithErrors) {
    setTimeout(() => {
      if (typeof setCurrentTabKey === 'function') {
        switch (formWithErrors.parentTabKey) {
          case 'operativos':
            setCurrentTabKeyDO(formWithErrors.tabKey);
            break;
          case 'pago':
            break;
          default:
            setCurrentTabKey(formWithErrors.tabKey);
        }
        setCurrentParentTabKey(formWithErrors.parentTabKey);
      }
    });
  }
};

export const ConfiguracionSeguroIMSSPermission = {
  permissionModel: 'seguroimss',
};

const onClickTitle = (e) => {
  const element = e.target;
  if (element) {
    let parent = element.parentElement;
    parent = parent ? parent.parentElement : null;
    if (parent) {
      const clickableSpan = parent.previousSibling;
      if (clickableSpan) {
        clickableSpan.click();
      }
    }
  }
};

const renderTitle = (title, bold) => (
  // eslint-disable-next-line
  <span onClick={onClickTitle} className={bold ? 'bold' : ''}>
    {title}
  </span>
);

function normalizeSeguro(_data, prop = 'nombre') {
  const nodeMap = new Map();
  const treeS = [];
  _data.forEach((node) => {
    nodeMap.set(node.id, { ...node, children: [] });
  });
  _data.forEach((node) => {
    if (node.seguros_de_seguridad_social_padre !== null) {
      const parent = nodeMap.get(node.seguros_de_seguridad_social_padre);
      if (parent) {
        const clone = nodeMap.get(node.id);
        parent.children.push({
          ...clone,
          key: `${clone.seguridad_social}/${clone.id}`,
          value: `${clone.seguridad_social}/${clone.id}`,
          title: renderTitle(`${clone.seguridad_social} - ${clone?.[prop]}`, !clone.selectable),
        });
      }
    } else {
      const clone = nodeMap.get(node.id);
      treeS.push({
        ...clone,
        key: `${clone.seguridad_social}/${clone.id}`,
        value: `${clone.seguridad_social}/${clone.id}`,
        title: renderTitle(`${clone.seguridad_social} - ${clone?.[prop]}`, !clone.selectable),
      });
    }
  });
  return treeS;
}

const normalizeTreeCog = (_data) => {
  const newData = {};

  _data.forEach((item) => {
    const clone = { ...item };
    const title = `${clone.clave} - ${clone.concepto}`;
    clone.title = renderTitle(title);
    clone.value = clone.id;
    clone.key = clone.id;

    if (clone.clave_padre_id) {
      const padre = newData[clone.clave_padre_id];
      if (padre) {
        clone.key = `${padre.clave}/${clone.id}`;
        clone.value = clone.id;
        padre.seleccionable = false;
        padre.children = padre.children || [];
        padre.children.push(clone);
      }
    }
    if (!newData[clone.id]) {
      newData[clone.id] = clone;
      clone.children = clone.children || undefined;
      clone.seleccionable = true;
    }
  });
  const capitulosCog = Object.values(newData).filter((item) => !item.clave_padre_id);
  return capitulosCog;
};

function normalizeFDF(_data, prop = 'nombre') {
  const nodeMap = new Map();
  const tree = [];
  _data.forEach((node) => {
    nodeMap.set(node.id, { ...node, children: [] });
  });
  _data.forEach((node) => {
    if (node.clave_padre !== null) {
      const parent = nodeMap.get(node.clave_padre);
      if (parent) {
        const clone = nodeMap.get(node.id);
        parent.children.push({
          ...clone,
          key: `${clone.clave}/${clone.id}`,
          value: clone.id,
          title: renderTitle(`${clone.clave} - ${clone?.[prop]}`, !clone.selectable),
        });
      }
    } else {
      const clone = nodeMap.get(node.id);
      tree.push({
        ...clone,
        key: `${clone.clave}/${clone.id}`,
        value: clone.id,
        title: renderTitle(`${clone.clave} - ${clone?.[prop]}`, !clone.selectable),
      });
    }
  });
  return tree;
}

function normalizeFinanciamiento(_data) {
  const nodeMap = new Map();
  const securityMap = new Map();

  _data.forEach((node) => {
    nodeMap.set(node.id, { ...node, children: [] });
  });

  _data.forEach((node) => {
    if (node.clave_padre !== null) {
      const parent = nodeMap.get(node.clave_padre);
      if (parent) {
        const clone = nodeMap.get(node.id);
        parent.children.push({
          ...clone,
          key: `${clone.clave}/${clone.id}`,
        });
      }
    } else {
      if (!securityMap.has(node.clave)) {
        securityMap.set(
          node.clave,
          { clave: node.clave, children: [] },
        );
      }
      const clone = nodeMap.get(node.id);
      securityMap.get(node.clave).children.push({
        ...clone,
        key: `${clone.nombre}/${clone.id}`,
      });
    }
  });
  // Convertir securityMap en un array de primer nivel
}

const normalizeSimpleData = (_data) => {
  const result = [];
  const processNode = (node) => {
    const copy = { ...node };
    result.push(copy);
    if (copy.children && copy.children.length) {
      copy.children.forEach((child) => {
        processNode(child);
      });
    }
    copy.children = undefined;
  };
  _data.forEach(processNode);

  return result;
};

const ConfiguracionSeguroIMSS = ({ permission }) => {
  const { estadosGlobales } = useSelector(((state) => state.catalogos));
  const [formSerch] = Form.useForm();
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [disableFields, setDisableFields] = useState(false);
  const [catalogosDeModalidadDeSeguridadSocial, setCatalogosDeModalidadDeSeguridadSocial] = useState([]);
  const [seguridadSocial, setSeguridadSocial] = useState([]);
  const [baseDeCalculo, setBaseDeCalculo] = useState([]);
  const [periodicidadDeSeguroSocial, setPeriodicidadDeSeguroSocial] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [dataUnion, setDataUnion] = useState([]);
  const [simpleData, setSimpleData] = useState([]);
  const [fuentesDeFinanciamiento, setFuentesDeFinanciamiento] = useState([]);
  const [clasificacionTipoGasto, setClasificacionTipoGasto] = useState([]);
  const [catalogoDecuentasContablesPasivo, setCatalogoDeCuentasContablesPasivo] = useState([]);
  const [cuentasContablesPasivoEmpleado, setCuentasContablesPasivoEmpleado] = useState([]);
  const [cuentasContablesPasivoPatronal, setCuentasContablesPasivoPatronal] = useState([]);
  const [valorParaElCalculo, setValorParaElCalculo] = useState([]);
  const [tipoCuenta, setTipoCuenta] = useState('general');
  const [tipoCuentaEmpleado, setTipoCuentaEmpleado] = useState('general');
  const [currentParentTabKey, setCurrentParentTabKey] = useState('general');

  const [unidadesResponsables, setUnidadesResponsables] = useState([]);
  const [unidadesOperativas, setUnidadesOperativas] = useState([]);
  const [centrosDeCostos, setCentrosDeCostos] = useState([]);
  const [arbolJerarquico, setArbolJerarquico] = useState([]);
  const [catalogoCuentaContable, setCatalogoCuentaContable] = useState([]);
  const [fuentesFinanciamiento, setFuentesFinanciamiento] = useState([]);
  const [listaFuentes, setListaFuentes] = useState([]);

  const patronal = Form.useWatch('porcentaje_aportacion_patronal', form);
  const trabajador = Form.useWatch('porcentaje_aportacion_trabajador', form);

  useEffect(() => {
    const total = (parseFloat(patronal) || 0) + (parseFloat(trabajador) || 0);
    form.setFieldsValue({
      total_porcentaje_aportaciones: parseFloat(total.toFixed(3)),
    });
  }, [patronal, trabajador, form]);

  const fetchData = async () => {
    setLoading(true);
    const _data = await getConfiguracionesSeguroIMSS();
    setData(formatReceived(_data));
    setLoading(false);
  };

  function mergeUnidades(idClaveDescripcionN1 = [], idClaveDescripcionN2 = [], idClaveDescripcionN3 = []) {
    return [
      ...idClaveDescripcionN1,
      ...idClaveDescripcionN2,
      ...idClaveDescripcionN3,
    ].map(({ id, clave, descripcion }) => ({
      id,
      clave,
      descripcion,
    }));
  }

  const normalizeCuentasContables = (_data) => {
    if (_data) {
      const output = _data.map((item) => {
        const clone = { ...item };
        const children = normalizeCuentasContables(clone.children);
        const hasCuentasChildren = children.some((e) => e.conac);
        const selectable = clone.tipo !== 7 && !hasCuentasChildren;
        if (!children.length) {
          delete clone.children;
          return ({
            ...clone,
            title: `${clone.clave_visible || clone.clave} - ${clone.nombre}`,
            value: clone.id,
            key: clone.id,
            disabled: !selectable,
          });
        }
        return ({
          ...clone,
          title: `${clone.clave_visible || clone.clave} - ${clone.nombre}`,
          value: clone.id,
          key: clone.id,
          children,
          disabled: !selectable,
        });
      });
      return output;
    }
    return [];
  };

  const formatDataTreeFDF = (_data = []) => _data.map((item) => {
    const clone = { ...item };
    const hasChildren = clone.children && clone.children.length > 0;

    const children = hasChildren ? formatDataTreeFDF(clone.children) : [];

    if (!children.length) {
      delete clone.children;
      return {
        ...clone,
        key: clone.id,
        value: clone.id,
        title: renderTitle(`${clone.clave} - ${clone.nombre}`, true),
        disabled: false, // Nodo hoja: habilitado
      };
    }

    return {
      ...clone,
      key: clone.id,
      value: clone.id,
      children,
      title: renderTitle(`${clone.clave} - ${clone.nombre}`, false),
      disabled: true, // Nodo padre: bloqueado
    };
  });

  const normalize = (_data = [], level = 0, visited = new Set()) => _data.map((item, index) => {
    const clone = { ...item };
    const uniqueId = clone.id ?? clone.clave;

    if (visited.has(uniqueId)) {
      return null;
    }

    visited.add(uniqueId);

    const children = Array.isArray(clone.children)
      ? normalize(clone.children, level + 1, new Set(visited))
      : [];

    return {
      ...clone,
      key: clone.id,
      value: clone.id,
      title: renderTitle(`${clone.clave} - ${clone.nombre}`, children.length > 0),
      disabled: item.seleccionable === false,
      children: children.length ? children : undefined,
    };
  }).filter(Boolean);

  const formatDataTree = (_data = [], excludeLvl3 = false, currLvl = 1) => _data.map((item) => {
    const clone = { ...item };

    const children = formatDataTree(
      !excludeLvl3 || currLvl !== 2 ? clone.children || [] : [],
      excludeLvl3,
      currLvl + 1,
    );

    const node = {
      key: clone.key || clone.id?.toString(),
      value: clone.value || clone.id?.toString(),
      title: clone.title,
      disabled: !clone.seleccionable,
      children, // mantener siempre
    };

    return node;
  });

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _catalogosDeModalidadDeSeguridadSocial,
        _seguridadSocial,
        _baseDeCalculo,
        _periodicidadDeSeguroSocial,
        _dataUnion,
        _clasificacionTipoGasto,
        _fuentesDeFinanciamiento,
        _fuentesDeFinanciamientoInterna,
        _valorParaElCalculo,
        _catalogoDeCuentasContablesPasivo,
        _cuentasContablesPasivoEmpleado,
        _cuentasContablesPasivoPatronal,
        _centrosDeCostos,
        _unidadesResponsables,
        _unidadesOperativas,
        _catalogoCuentasContables,
        _data,
        _fuentesClasificacion,
      ] = await Promise.all([
        getCatalogosDeModalidadDeSeguridadSocial(),
        getSeguridadsociales(),
        getBaseDeCalculos(),
        getPeriodicidadDeSeguridadSociales(),
        getClasificadoresObjetoGastoUnion(),
        getClasificacionesTipoGasto(),
        getFuentesDeFinanciamiento(),
        getFuentesDeFinanciamientoContabilidad(),
        getValoresParaElCalculo(),
        getCatalogosDeCuentasContablesPasivo(),
        getCuentasContablesPasivoEmpleado(),
        getCuentasContablesPasivoPatronal(),
        getCentrosDeCostos(),
        getUnidadesResponsables(),
        getUnidadesOperativas(),
        getCuentasContables(),
        getConfiguracionesSeguroIMSS(),
        API.get('contabilidad/clasificaciones-de-fuentes-de-financiamiento/'),
      ]);
      const formattedDataUnion = normalizeTreeCog(_dataUnion);
      const _simpleData = normalizeSimpleData(formattedDataUnion);
      if (mounted) {
        setTreeData(formattedDataUnion);
        setCatalogosDeModalidadDeSeguridadSocial(_catalogosDeModalidadDeSeguridadSocial
          ?.filter((item) => item.seguridad_social_padre === 1));
        setSeguridadSocial(normalizeSeguro(_seguridadSocial));
        setFuentesDeFinanciamiento(normalizeFinanciamiento(_fuentesDeFinanciamiento));
        setBaseDeCalculo(_baseDeCalculo);
        setPeriodicidadDeSeguroSocial(_periodicidadDeSeguroSocial);
        setDataUnion(formattedDataUnion);
        setSimpleData(_simpleData);
        setClasificacionTipoGasto(_clasificacionTipoGasto);
        setValorParaElCalculo(_valorParaElCalculo);
        setCatalogoDeCuentasContablesPasivo(_catalogoDeCuentasContablesPasivo);
        setCuentasContablesPasivoEmpleado(_cuentasContablesPasivoEmpleado);
        setCuentasContablesPasivoPatronal(_cuentasContablesPasivoPatronal);
        setValorParaElCalculo(_valorParaElCalculo);
        setFuentesDeFinanciamiento(normalizeFDF(_fuentesDeFinanciamiento));
        // setFuentesDeFinanciamientoContabilidad(normalizeFDF(_fuentesDeFinanciamientoInterna));
        setUnidadesResponsables(normalizeSimpleData(_unidadesResponsables)); // <--
        setUnidadesOperativas(normalizeSimpleData(_unidadesOperativas)); // <--
        setCentrosDeCostos(normalizeSimpleData(_centrosDeCostos)); // <--
        setData(formatReceived(_data));

        const fuentesTree = makeTree(_fuentesClasificacion.data);
        const normalized = normalize(fuentesTree);

        setListaFuentes(_fuentesClasificacion.data);
        setFuentesFinanciamiento(formatDataTree(normalized));

        // Aquí usas la función personalizada:
        const jerarquia = mergeUnidades(
          _unidadesOperativas,
          _unidadesResponsables,
          _centrosDeCostos,
        );
        setArbolJerarquico(jerarquia);

        const normalizedCuentas = normalizeCuentasContables(makeTreeCuentasContable(_catalogoCuentasContables));
        setCatalogoCuentaContable(normalizedCuentas); // <--

        // Las que tienen flechitas, deben normalizarce en un solo array con si ID y descripcion, para que sea un desplegable
        // tipo arbol y mostrarlo en el select de Cuenta Contable del Pasivo Patronal -> General

        // eslint-disable-next-line max-len
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    fetchData();
  };

  const onClickEdit = () => {
    setLoading(true);
    const [key] = selectedRowKeys;
    if (!([1].includes(key))) {
      const match = data?.find((item) => item.id === key);

      if (match) {
        form.resetFields();
        setTipoCuenta(match.catalogo_contable_del_pasivo_patronal);
        setTipoCuentaEmpleado(match.catalogo_contable_del_pasivo_empleado);

        setTimeout(() => {
          const registro = {
            ...formatReceived(match),
            modalidad: match.modalidad?.id || match.modalidad,
            vigencia_hasta: match.vigencia_hasta ? moment(match.vigencia_hasta) : null,
          };

          form.setFieldsValue(registro);
          setDisableFields(match?.estados_globales !== ESTATUS_ACTIVO);
          setVisible(true);
        });
      }
    } else {
      message.warn('Este registro no es editable');
    }
    setLoading(false);
  };

  const requiredFormStructure = [
    {
      parentTabKey: 'general',
      tabKey: 'general',
      tabFields: ['seguridad_social', 'clave', 'porcentaje_aportacion_patronal',
        'porcentaje_aportacion_trabajador', 'base_de_calculo', 'tope_base',
        'valor_para_tope_base', 'periodicidad_de_pago', 'estados_globales'],
    },
    {
      parentTabKey: 'registro',
      tabKey: 'registro',
      tabFields: ['clasificador_de_objeto_de_gasto', 'fuente_de_financiamiento',
        'tipo_de_gasto', 'catalogo_contable_del_pasivo_patronal',
        'cuenta_contable_del_pasivo_patronal', 'catalogo_contable_del_pasivo_empleado',
        'cuenta_contable_del_pasivo_empleado'],
    },
  ];

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;

      const saved = await (key
        ? patchConfiguracionSeguroIMSS(key, values)
        : postConfiguracionSeguroIMSS(values));

      if (saved) {
        onCancel();
        await fetchData();
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onFinishFailed = ({ errorFields }) => {
    onErrorFields(
      { errorFields },
      setLoading,
      requiredFormStructure,
      setCurrentParentTabKey,
      undefined,
      setCurrentParentTabKey,
    );
    message.warn('Favor de corregir los errores señalados');
  };
  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteConfiguracionSeguroIMSS(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    form.resetFields();
    setTipoCuenta('general');
    setTipoCuentaEmpleado('general');
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onChangeModalidad = async (modalidadId) => {
    if (modalidadId) {
      const _data = await getConfiguracionesSeguroIMSS({
        seguridad_social: modalidadId,
      });
      setData(formatReceived(_data));
    } else {
      setData([]);
    }
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Seguro',
      dataIndex: 'seguro',
      key: 'seguro',
      width: 300,
      render: (val) => seguridadSocial.find((e) => e.id === val)?.nombre || 'No encontrada',
    },
    {
      titleText: '% Patron',
      dataIndex: 'porcentaje_aportacion_patronal',
      key: 'porcentaje_aportacion_patronal',
      width: 150,
      render: (val) => `${parseFloat(val).toFixed(4)} %`,
    },
    {
      titleText: '% Trabajador',
      dataIndex: 'porcentaje_aportacion_trabajador',
      key: 'porcentaje_aportacion_trabajador',
      width: 150,
      render: (val) => `${parseFloat(val).toFixed(4)} %`,
    },
    {
      titleText: '% Total',
      dataIndex: 'total_porcentaje_aportaciones',
      key: 'total_porcentaje_aportaciones',
      width: 150,
      render: (val) => `${parseFloat(val).toFixed(4)} %`,
    },
    {
      titleText: 'Base de Cálculo',
      dataIndex: 'base_de_calculo',
      key: 'base_de_calculo',
      width: 200,
      render: (val) => baseDeCalculo.find((e) => e.id === val)?.base || 'No encontrada',
    },
    {
      titleText: 'Tope de Base',
      dataIndex: 'tope_base',
      key: 'tope_base',
      width: 200,
      render: (val) => `${val} UMA`,
    },
    {
      titleText: 'Periodicidad de Pago',
      dataIndex: 'periodicidad_de_pago',
      key: 'periodicidad_de_pago',
      width: 200,
      render: (val) => periodicidadDeSeguroSocial.find((e) => e.id === val)?.periodicidad || 'No encontrada',
    },
    {
      titleText: 'COG',
      dataIndex: 'clasificador_de_objeto_de_gasto',
      key: 'clasificador_de_objeto_de_gasto',
      width: 200,
      render: (val) => {
        const _cogs = simpleData.find((e) => e.id === val);
        return (_cogs?.clave ? `${_cogs?.clave} - ${_cogs?.concepto}` : '');
      },
    },
    {
      titleText: 'Fuente de Financiamiento',
      dataIndex: 'fuente_de_financiamiento',
      key: 'fuente_de_financiamiento',
      width: 300,
      render: (val) => {
        const _fuentesDeFinanciamiento = fuentesDeFinanciamiento.find((e) => e.id === val);
        return (_fuentesDeFinanciamiento?.clave ? `${_fuentesDeFinanciamiento?.clave} - ${_fuentesDeFinanciamiento?.nombre}` : '');
      },
    },
    {
      titleText: 'Tipo de Gasto',
      dataIndex: 'tipo_de_gasto',
      key: 'tipo_de_gasto',
      width: 300,
      render: (val) => {
        const _tipoDeGasto = clasificacionTipoGasto.find((e) => e.id === val);
        return (_tipoDeGasto?.clave ? `${_tipoDeGasto?.clave} - ${_tipoDeGasto?.nombre}` : '');
      },
    },
    {
      titleText: 'Cuenta del Pasivo Patronal',
      dataIndex: 'cuenta_contable_del_pasivo_patronal',
      key: 'cuenta_contable_del_pasivo_patronal',
      width: 300,
      render: (val) => cuentasContablesPasivoPatronal.find((e) => e.id === val)?.nombre || 'No encontrada',

    },
    {
      titleText: 'Cuenta del Pasivo del Empleado',
      dataIndex: 'cuenta_contable_del_pasivo_empleado',
      key: 'cuenta_contable_del_pasivo_empleado',
      width: 300,
      render: (val) => cuentasContablesPasivoEmpleado.find((e) => e.id === val)?.nombre || 'No encontrada',
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 200,
    },
    {
      titleText: 'Fundamento',
      dataIndex: 'fundamento',
      key: 'fundamento',
      width: 200,
    },
    {
      titleText: 'Vigencia Hasta',
      dataIndex: 'vigencia_hasta',
      key: 'vigencia_hasta',
      width: 200,
      render: (val) => (val ? moment(val).format(DATE_FRONTEND_FORMAT) : 'null'),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estadosGlobales.find((e) => e.id === val)?.descripcion,
    },

  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    nombre: [
      requiredRule,
      {
        pattern: NOMBRES_PATTERN,
        message: 'Ingrese un nombre válido',
      },
    ],
    clave: [
      requiredRule,
      {
        validator: async (_, value) => {
          const { clave_padre } = form.getFieldValue();
          const numeroEnteroBooleano = /^\d+$/.test(value);
          const cogPadre = simpleData.find((e) => e.id === clave_padre);
          if (!value.startsWith(cogPadre.clave.toString()) || !numeroEnteroBooleano) {
            throw new Error('La clave debe ser un número e iniciar con la clave padre y un dígito más.');
          }
          if (value.length > 4) {
            throw new Error('La clave no debe de pasar los 4 dígitos.');
          }
        },
      },
    ],
  };

  // columnas de tabla Cuenta Contable Por Área Patronal
  const columnasDeTablaCuentaContablePorAreaPatronal = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 50,
    },
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 300,
    },
  ];

  // columnas de tabla Cuenta Contable Por Área Empleado
  const columnasDeTablaCuentaContablePorAreaEmpleado = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 50,
    },
    {
      titleText: 'Seguro',
      dataIndex: 'seguro',
      key: 'seguro',
      width: 300,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Form
          layout="vertical"
          form={formSerch}
          name="general"
        >
          {!open && (
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="seguridad_social"
                label="Modalidad"
              >
                <Select
                  labelProp="modalidad"
                  dataSource={catalogosDeModalidadDeSeguridadSocial}
                  onChange={onChangeModalidad}
                />
              </Form.Item>
            </Col>
          )}
        </Form>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            datas={dataUnion}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            customDataArbolado={simpleData}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
            permission={permission}
          />
        ) : (
          <Card
            className="form-container"
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              scrollToFirstError
              name="configuracionSeguroIMSS"
              initialValues={{
                estados_globales: ESTATUS_ACTIVO,
                modo_cuenta: 'general',
              }}
            >
              <FormSubmitControls
                label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Seguro IMSS`}
                onFinish={() => form.submit()}
                onCancel={onCancel}
                loading={loading}
                // allowSave={!disableFields}
              />
              <Tabs
                type="card"
                activeKey={currentParentTabKey}
                onChange={setCurrentParentTabKey}
              >
                <TabPane tab="General" key="general" forceRender>
                  <Row gutter={10}>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="seguridad_social"
                        label="Modalidad"
                        rules={rules.required}
                        hasFeedback
                      >
                        <Select
                          labelProp="modalidad"
                          dataSource={catalogosDeModalidadDeSeguridadSocial}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="clave"
                        label="Clave"
                        rules={rules.required}
                        hasFeedback
                      >
                        <Input
                          allowClear
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="seguro"
                        label="Seguro"
                       // rules={rules.required}
                        hasFeedback
                      >
                        <TreeSelect
                          showSearch
                          allowClear
                          treeDefaultExpandAll
                          placeholder=" "
                          treeNodeFilterProp="title"
                          treeNodeLabelProp="title"
                          fieldNames={{
                            label: 'title',
                            value: 'id',
                            children: 'children',
                          }}
                          treeData={
                            seguridadSocial
                              ?.filter((item) => item.seguridad_social === 1)
                              .map((item) => ({
                                ...item,
                                title: item.nombre.replace(/^\d+\s*-\s*/, ''),
                                children: item.children?.map((child) => ({
                                  ...child,
                                  title: child.nombre.replace(/^\d+\s*-\s*/, ''),
                                })),
                              }))
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="porcentaje_aportacion_patronal"
                        label="% Aportación Patronal"
                        rules={rules.required}
                        hasFeedback
                      >
                        <InputNumber
                          min={0}
                          max={100}
                          step={0.001}
                          precision={4}
                          style={{ width: '100%' }}
                          addonAfter="%"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="porcentaje_aportacion_trabajador"
                        label="% Aportación Trabajador"
                        rules={rules.required}
                        hasFeedback
                      >
                        <InputNumber
                          min={0}
                          max={100}
                          step={0.001}
                          precision={4}
                          style={{ width: '100%' }}
                          addonAfter="%"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="total_porcentaje_aportaciones"
                        label="Total % Aportaciones"
                        hasFeedback
                      >
                        <InputNumber
                          min={0}
                          max={100}
                          step={0.001}
                          precision={4}
                          style={{ width: '100%' }}
                          addonAfter="%"
                          dataSource={data}
                          disabled
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="base_de_calculo"
                        label="Base de Cálculo"
                        rules={rules.required}
                        hasFeedback
                      >
                        <Select
                          labelProp="base"
                          keyProp="id"
                          dataSource={baseDeCalculo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="tope_base"
                        label="Tope de Base"
                        rules={rules.required}
                        hasFeedback
                      >
                        <InputNumber
                          min={0}
                          max={999}
                          step={0.001}
                          precision={4}
                          style={{ width: '100%' }}
                          addonAfter="UMA"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="valor_para_tope_base"
                        label="Valor para Tope de Base"
                        rules={rules.required}
                        hasFeedback
                      >
                        <Select
                          labelProp="clave"
                          keyProp="id"
                          dataSource={valorParaElCalculo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="periodicidad_de_pago"
                        label="Periodicidad de Pago"
                        rules={rules.required}
                        hasFeedback
                      >
                        <Select
                          labelProp="periodicidad"
                          keyProp="id"
                          dataSource={periodicidadDeSeguroSocial
                            ?.filter((item) => item.seguridad_social === 1)}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="fundamento"
                        label="Fundamento"
                        hasFeedback
                      >
                        <Input
                          allowClear
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="observaciones"
                        label="Observaciones"
                        hasFeedback
                      >
                        <Input
                          allowClear
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="vigencia_hasta"
                        label="Vigencia hasta"
                        hasFeedback
                      >
                        <DatePicker
                          format="DD/MM/YYYY"
                          style={{ width: '100%' }}
                          allowClear
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="estados_globales"
                        label="Estatus"
                        rules={rules.required}
                        hasFeedback
                      >
                        <Select
                          labelProp="descripcion"
                          keyProp="id"
                          dataSource={estadosGlobales}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </TabPane>

                <TabPane tab="Registro" key="registro" forceRender>
                  <Row gutter={10}>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="clasificador_de_objeto_de_gasto"
                        label="Clasificador de Objeto de Gasto"
                        rules={rules.required}
                        hasFeedback
                      >
                        <TreeSelect
                          showSearch
                          treeNodeFilterProp="title"
                          treeData={treeData}
                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                          onChange={(val) => {
                            const cogPadre = simpleData.find((e) => e.id === val);
                            form.setFieldValue('clave', cogPadre.clave);
                          }}
                        />
                      </Form.Item>
                    </Col>

                    {/* Fuente de Financiamiento */}
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="fuente_de_financiamiento"
                        label="Fuente de Financiamiento"
                        rules={[{ required: true, message: 'Seleccione una fuente de financiamiento' }]}
                      >
                        <TreeSelect
                          showSearch
                          treeNodeFilterProp="title"
                          style={{ width: '100%' }}
                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                          treeData={fuentesFinanciamiento}
                          allowClear
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="tipo_de_gasto"
                        label="Tipo de Gasto"
                        rules={rules.required}
                        hasFeedback
                      >
                        <Select
                          labelProp="nombre"
                          keyProp="id"
                          dataSource={clasificacionTipoGasto}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[10, 10]}>
                    {/* Selector de Cuenta Patronal */}
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="catalogo_contable_del_pasivo_patronal"
                        label="Cuenta Contable del Pasivo Patronal"
                        rules={rules.required}
                      >
                        <Select
                          labelProp="cuenta_contable"
                          keyProp="id"
                          render={(item) => `${item?.nombre}`}
                          dataSource={catalogoDecuentasContablesPasivo}
                          onChange={setTipoCuenta}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24}>
                      {/* Detalle extra de cuenta patronal */}
                      {tipoCuenta === 1 && (
                        <Col span={24}>
                          <Form.Item
                            name="cuenta_contable_del_pasivo_patronal"
                            label="Detalle del Catálogo Patronal"
                            rules={rules.required}
                            hasFeedback
                          >
                            {/* <Select
                              render={(item) => `${item?.clave} - ${item?.nombre}`}
                              dataSource={catalogoCuentaContable}
                            /> */}
                            <TreeSelect
                              keyProp="clave"
                              labelProp="nombre"
                              showSearch
                              treeNodeFilterProp="title"
                              treeData={catalogoCuentaContable}
                            />
                          </Form.Item>
                        </Col>
                      )}

                      {/* Tabla si es tipo 2 */}
                      {tipoCuenta === 2 && (
                        <Row span={24}>
                          <Table
                            cols={columnasDeTablaCuentaContablePorAreaPatronal}
                            data={arbolJerarquico}
                            // datas={dataUnion}
                            rowSelection={rowSelection}
                            handleOnRowClick={handleOnRowClick}
                            // customDataArbolado={simpleData}
                            // controls={{
                            //   onClickAdd,
                            //   onClickEdit: () => onClickEdit(),
                            //   onClickDelete,
                            // }}
                            disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
                            permission={permission}
                          />
                        </Row>
                      )}
                    </Col>

                    {/* Selector de Cuenta Empleado */}
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="catalogo_contable_del_pasivo_empleado"
                        label="Cuenta Contable del Pasivo del Empleado"
                        rules={rules.required}
                      >
                        <Select
                          labelProp="cuenta_contable_empleado"
                          keyProp="id"
                          render={(item) => `${item?.nombre}`}
                          dataSource={catalogoDecuentasContablesPasivo}
                          onChange={setTipoCuentaEmpleado}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={24}>
                      {/* Detalle extra de cuenta empleado */}
                      {tipoCuentaEmpleado === 1 && (
                        <Col span={24}>
                          <Form.Item
                            name="cuenta_contable_del_pasivo_empleado"
                            label="Detalle del Catálogo Empleado"
                            rules={rules.required}
                            hasFeedback
                          >
                            <TreeSelect
                              keyProp="clave"
                              labelProp="nombre"
                              showSearch
                              treeNodeFilterProp="title"
                              treeData={catalogoCuentaContable}
                            />
                          </Form.Item>
                        </Col>
                      )}
                      {/* Tabla si es tipo 2 */}
                      {tipoCuentaEmpleado === 2 && (
                        <Row span={24}>
                          <Table
                            cols={columnasDeTablaCuentaContablePorAreaPatronal}
                            data={arbolJerarquico}
                            // datas={dataUnion}
                            rowSelection={rowSelection}
                            handleOnRowClick={handleOnRowClick}
                            // customDataArbolado={simpleData}
                            // controls={{
                            //   onClickAdd,
                            //   onClickEdit: () => onClickEdit(),
                            //   onClickDelete,
                            // }}
                            disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
                            permission={permission}
                          />
                        </Row>
                      )}
                    </Col>
                  </Row>

                </TabPane>

              </Tabs>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content="El registro seleccionado"
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default ConfiguracionSeguroIMSS;
